import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getDeviceInfo } from '@/utils/device-detection';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';

const UpdateBrowser: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const deviceInfo = getDeviceInfo();
  const { user, token, logout, logoutAll, logoutToken } = useAuth();

  const handleLogoutSession = async () => {
    logout();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-center">
            {t('update.browser.title', 'Mise à jour de navigateur requise')}
          </CardTitle>
          <CardDescription className="text-center">
            {t('update.browser.description', 'Votre version de Safari n\'est pas compatible avec cette application.')}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-amber-50 text-amber-800 p-4 rounded-md border border-amber-200">
            <h3 className="font-semibold mb-2">
              {t('update.browser.detected', 'Navigateur détecté:')} {deviceInfo.browser} {deviceInfo.browserVersion}
            </h3>
            <p>
              {t('update.browser.minimumVersion', 'Version minimale requise pour Safari: 15.0')}
            </p>
          </div>
          <div className="space-y-2">
            <p>
              {t('update.browser.explanation', 'Pour utiliser cette application, veuillez mettre à jour Safari vers la version 15.0 ou supérieure, ou utiliser un autre navigateur comme Chrome, Firefox ou Edge.')}
            </p>
            <p>
              {t('update.browser.instruction', 'Sur macOS, mettez à jour votre système d\'exploitation pour obtenir les dernières versions de Safari. Sur iOS, mettez à jour vers la dernière version d\'iOS.')}
            </p>
          </div>
        </CardContent>
        <CardFooter className="flex flex-col items-center space-y-2">
          <Button
            variant="outline"
            onClick={() => handleLogoutSession()}
            className="w-full"
          >
            {t('update.browser.goHome', 'Retour à l\'accueil')}
          </Button>
          <Button
            onClick={() => window.location.href = 'https://support.apple.com/fr-fr/HT201541'}
            className="w-full"
          >
            {t('update.browser.learnMore', 'Comment mettre à jour Safari')}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default UpdateBrowser;
